import { useState } from 'react';

export const useConfirmation = () => {
    const [modalState, setModalState] = useState({
        isOpen: false,
        title: '',
        message: '',
        confirmText: 'OK',
        cancelText: 'Cancel',
        confirmButtonColor: 'bg-[#FF3B30]',
        onConfirm: null
    });

    const showConfirmation = ({
        title = '',
        message = '',
        confirmText = 'OK',
        cancelText = 'Cancel',
        confirmButtonColor = 'bg-[#FF3B30]',
        onConfirm = null
    }) => {
        setModalState({
            isOpen: true,
            title,
            message,
            confirmText,
            cancelText,
            confirmButtonColor,
            onConfirm
        });
    };

    const handleConfirm = () => {
        if (modalState.onConfirm) {
            modalState.onConfirm();
        }
        closeConfirmation();
    };

    const closeConfirmation = () => {
        setModalState(prev => ({
            ...prev,
            isOpen: false
        }));
    };

    return {
        modalState,
        showConfirmation,
        handleConfirm,
        closeConfirmation
    };
};
